







import { expandCloudinary, expandPath } from "@/api/helpers";
import { MediaItem } from "@/api/models";
import { bus } from "@/main";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { notEmptyString } from "../../api/validators";

@Component({
  components: {},
  filters: {},
})
export default class FigureWidget extends Vue {
  @Prop({ default: () => new MediaItem() }) mediaItem: MediaItem;
  @Prop({ default: "" }) fileRef: string;
  @Prop({ default: "" }) mouseoverHint: string;
  @Prop({ default: "" }) source: string;
  @Prop({ default: "" }) alt: string;
  @Prop({ default: "thumb" }) size: string;

  tsString = "";

  updatingTs = false;

  switching = false;

  imagesLoaded = false;

  created() {
    bus.$on("statement-image", ({ refKey }) => {
      if (notEmptyString(this.fileRef) && this.fileRef.includes(refKey)) {
        setTimeout(this.updateTs, 1500);
        setTimeout(this.updateTs, 5000);
      }
    });
  }

  mounted() {
    this.updateTs();
  }

  updateTs() {
    if (!this.updatingTs) {
      this.updatingTs = true;
      const ts = new Date().getTime() % (3600 * 1000);
      this.tsString = ["#ts", ts].join("=");
      setTimeout(() => {
        this.updatingTs = false;
      }, 1000);
    }
  }

  onImageLoad(e) {
    if (e) {
      this.imagesLoaded = true;
    }
  }

  get isDirectRef() {
    return notEmptyString(this.fileRef, 6);
  }

  get figureClasses() {
    const cls = [this.size];
    if (!this.isDirectRef) {
      if (this.mediaItem.attributes) {
        const { width, height } = this.mediaItem.attributes;
        const isLandscape = height < width;
        const isSquare = height > width * (3 / 4) && isLandscape;
        if (isSquare || !isLandscape) {
          cls.push("by-height");
        } else {
          cls.push("by-width");
        }
        if (isSquare) {
          cls.push("square");
        }
        if (isLandscape && !isSquare) {
          cls.push("tall");
        }
      }
    }
    return cls;
  }

  get filePath() {
    switch (this.matchedSource) {
      case "local":
        return expandPath(this.filename, this.size) + this.tsString;
      case "cloudinary":
      case "player":
        return expandCloudinary(this.filename, this.size);
      default:
        return this.filename;
    }
  }

  get altRef() {
    if (this.isDirectRef) {
      return this.alt;
    } else {
      return this.mediaItem.title;
    }
  }

  get filename() {
    return this.isDirectRef ? this.fileRef : this.mediaItem.filename;
  }

  get matchedSource() {
    let key = this.isDirectRef ? this.source : this.mediaItem.source;
    if (key.length < 2) {
      key = "local";
    }
    const hasCloudinaryPath = /res\.cloudinary/.test(this.filename);
    if (["local", "player"].includes(key)) {
      if (hasCloudinaryPath) {
        key = "cloudinary";
      }
    } else if (key === "cloudinary" && !hasCloudinaryPath) {
      if (!/^https?:/.test(this.filename)) {
        key = 'local';
      }
    }
    return key;
  }

  get imgClasses() {
    const cls = this.imagesLoaded? ['loaded'] : ['loading'];
    return cls;
  }

  @Watch("fileRef")
  changeFileRef() {
    this.imagesLoaded = false;
    this.switching = true;
    setTimeout(() => {
      this.updateTs();
    }, 1000);
    setTimeout(() => {
      this.switching = false;
    }, 250);
  }
}
